import { createLazyFileRoute } from "@tanstack/react-router";

import { IntegrationsPage } from "@/features/admin/routes/Integrations";

export const Route = createLazyFileRoute("/_auth/admin/integrations/")({
  component: IntegrationsPage,
});
